/**
 * @GENERATED from Figma node 3608:51003
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleDrawingsDark = (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#EA4335"
      d="M19.5 7v13.712c0 .711-.565 1.288-1.26 1.288H5.76c-.696 0-1.26-.577-1.26-1.288V3.288C4.5 2.577 5.064 2 5.76 2h8.74z"
    />
    <path
      fill="#fff"
      d="M10.125 14.917a2.31 2.31 0 0 1-2.292-2.292 2.31 2.31 0 0 1 2.292-2.292 2.31 2.31 0 0 1 2.292 2.292 2.31 2.31 0 0 1-2.292 2.292m0-3.75c-.792 0-1.458.666-1.458 1.458s.666 1.458 1.458 1.458 1.458-.666 1.458-1.458-.666-1.458-1.458-1.458m2.958 2.5a2.9 2.9 0 0 1-1.5 1.708v2.042h3.75v-3.75z"
    />
    <path fill="#C5221F" d="M19.5 7h-5V2z" />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleDrawingsDark);
export { ForwardRef as GoogleDrawingsDark };
